import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import 'core-js/features/object/values';
import 'core-js/features/string/starts-with';
import 'core-js/features/array/includes';
import 'core-js/modules/es.symbol';
import 'core-js/modules/es.function.bind';
import 'core-js/modules/es.map';
import 'core-js/modules/es.set';

import React from 'react';
import ReactDOM from 'react-dom';
import App from "./App";
import reportWebVitals from './reportWebVitals';
import store from './redux/store/store';
import { Provider } from 'react-redux';

import 'normalize-css';
import 'typeface-montserrat';
import 'typeface-raleway';
import 'typeface-roboto';

import { initAmplitude } from './utils/amplitude';
initAmplitude();

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
